import { ROLE_TYPE } from '../../types';
import { signupText, buttonsText, cookieServiceParam } from '../../utils/constants';
import { useNavigate } from "react-router-dom";
import React from 'react';
import { cookieService } from '../../services';
import { apiConstants } from '../../utils/apiConstants';
import RegisterLayout from '../profileSetupV2/crewProfileSetup/RegisterLayout';

const VerifyEmail: React.FC = () => {

  const navigate = useNavigate();

  const userType = cookieService.getCookie(cookieServiceParam.user)?.[apiConstants.user_type] || ROLE_TYPE.TYPE_SUPPLIER;

  const verifyEmail = () => {
    navigate(userType === ROLE_TYPE.TYPE_SUPPLIER ? '/subscription' : userType === ROLE_TYPE.TYPE_CREW ? '/manage-profile/crew/add/1' : '/manage-profile/owner/add/1');
  };

  return (
    <RegisterLayout hideHeader>
      <div className='verify-email-container'>

        <div className='top-content'>
          <img
            src={"/assets/images/bell-mail-icon.svg"}
            alt="verify-email"
            className='verify-email-icon'
          />

          <h3 className='verify-email-heading'>
            {signupText.verify_email}
          </h3>

          <p className='verify-email-description'>
            {signupText.send_verification_email}
          </p>
        </div>

        <form>
          <button
            className="btn-next btn-next--yellow"
            type='button'
            onClick={verifyEmail}
            style={{ marginTop: "20px", width: "100%" }}
          >
            {buttonsText.continue}
          </button>
        </form>

      </div>
    </RegisterLayout>
  );
};

export default VerifyEmail;